// Modules
import React from 'react'
import { Icon } from '@dasa-health/components-react'
import { MiscBoldQuestioncircle, SystemOutlineArrowleft } from '@dasa-health/icons'

// Application
import { InfoBoxProps } from 'typings/components'

// Component
import { StyledBox } from './styles'

export const InfoBox: React.FC<InfoBoxProps> = props => {
    const { link, openModal, title = '', paragraph = '', className } = props
    return (
        <StyledBox className={className}>
            <div className="header">
                <Icon size="large" variant="alert">
                    <MiscBoldQuestioncircle />
                </Icon>
                <h3 className="header__title">{title}</h3>
            </div>
            <p className="paragraph">{paragraph}</p>
            {link && (
                <a className="footer" href={link.to} rel="noreferrer" target="_blank">
                    {link.text}
                    <Icon className="footer__icon" size="large" variant="primary">
                        <SystemOutlineArrowleft />
                    </Icon>
                </a>
            )}
            {openModal && (
                <button
                    className="footer"
                    data-testid="button-infobox"
                    onClick={openModal.action}
                    onKeyDown={openModal.action}
                    type="button"
                >
                    {openModal.text}
                </button>
            )}
        </StyledBox>
    )
}
